import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['homeLoan', 'buildingCompletionDate']

  selectDate() {
    const selectedYear =
      this.buildingCompletionDateTarget.parentElement.querySelector(
        'select[name*="date(1i)"]'
      ).value
    const selectedMonth =
      this.buildingCompletionDateTarget.parentElement.querySelector(
        'select[name*="date(2i)"]'
      ).value
    const selectedDate = new Date(selectedYear, selectedMonth - 1)

    const current = new Date()
    const today = new Date(current.getFullYear(), current.getMonth())

    const tenYears = 10 * 365.25 * 24 * 60 * 60 * 1000
    const threeMonths = 93 * 24 * 60 * 60 * 1000
    if (
      selectedDate - today > -tenYears &&
      selectedDate - today < threeMonths
    ) {
      this.homeLoanTarget.classList.remove('hidden')
    } else {
      this.homeLoanTarget.classList.add('hidden')
    }
  }

  connect() {
    setTimeout(() => {
      this.buildingCompletionDateTarget.parentElement
        .querySelector('select[name*="date(1i)"]')
        .dispatchEvent(new Event('change'))
    }, 200)
  }
}
